import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getMyRequests } from '../../api/serviceRequests.api';
import '../../styles/user-dashboard.css';

const STATUS_LABELS = {
  pending: 'Pending', confirmed: 'Confirmed', dispatched: 'Dispatched',
  'in-progress': 'In Progress', completed: 'Completed', cancelled: 'Cancelled',
};

const MyBookings = () => {
  const [requests, setRequests] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    setLoading(true);
    getMyRequests({ page, limit: 10 })
      .then((data) => {
        setRequests(data.requests || []);
        setPagination(data.pagination || null);
      })
      .catch(() => setError('Failed to load bookings.'))
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <div className="bookings-page">
      <div className="bookings-container">
        <div className="bookings-header">
          <h1 className="bookings-title">My Bookings</h1>
          <Link to="/book-service" style={{
            padding: '0.625rem 1.25rem',
            background: '#2563eb',
            color: '#fff',
            borderRadius: 10,
            textDecoration: 'none',
            fontSize: '0.875rem',
            fontWeight: 600,
          }}>
            + New Request
          </Link>
        </div>

        {error && <div className="auth-error-box">{error}</div>}

        {loading ? (
          <div style={{ textAlign: 'center', padding: '4rem 0' }}>
            <div className="auth-spinner" style={{ margin: '0 auto' }} />
          </div>
        ) : requests.length === 0 ? (
          <div className="user-empty-state">
            <div className="user-empty-icon">📋</div>
            <div className="user-empty-text">No service requests yet</div>
            <Link to="/book-service" className="user-cta-link" style={{ justifyContent: 'center' }}>
              Book your first service
            </Link>
          </div>
        ) : (
          <>
            {requests.map((req) => (
              <div key={req.id} className={`booking-card status-${req.status}`}>
                <div className="booking-card-top">
                  <div>
                    <div className="booking-service-name">{req.serviceName || req.service?.name || 'Roadside Service'}</div>
                    {req.trackingId && <div className="booking-tracking">{req.trackingId}</div>}
                  </div>
                  <span className={`user-status-badge ${req.status}`}>
                    {STATUS_LABELS[req.status] || req.status}
                  </span>
                </div>
                <div className="booking-meta-row">
                  <div className="booking-meta-item">
                    <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    {new Date(req.createdAt).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </div>
                  {req.area?.name && (
                    <div className="booking-meta-item">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      {req.area.name}
                    </div>
                  )}
                  {req.finalPrice && (
                    <div className="booking-meta-item">
                      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                      </svg>
                      ₹{req.finalPrice.toLocaleString('en-IN')}
                    </div>
                  )}
                  {req.trackingId && (
                    <Link to={`/track-service?id=${req.trackingId}`} style={{ color: '#2563eb', fontSize: '0.8125rem', fontWeight: 600 }}>
                      Track →
                    </Link>
                  )}
                </div>
              </div>
            ))}

            {pagination && pagination.totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', gap: '0.5rem', marginTop: '1.5rem' }}>
                {Array.from({ length: pagination.totalPages }, (_, i) => i + 1).map((p) => (
                  <button
                    key={p}
                    onClick={() => setPage(p)}
                    style={{
                      width: 36, height: 36,
                      borderRadius: 8,
                      border: p === page ? '2px solid #2563eb' : '1.5px solid #e2e8f0',
                      background: p === page ? '#2563eb' : '#fff',
                      color: p === page ? '#fff' : '#374151',
                      fontWeight: 600,
                      cursor: 'pointer',
                    }}
                  >
                    {p}
                  </button>
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MyBookings;
